import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Proveedor, Select2Cliente, Select2SocioOtros } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { TiposSocioConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues, vTipoSocio }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.nombreSocio = data.razonSocial
      values.tipoDocumentoSocio = data.tipoDocumento

      setValues(values)

      KeyEventUtil.leaveOnKeyEvent('inputselect-glosa')
    })
  }

  const onCreateSocioHandler = React.useCallback(
    (socioCreado, closeModal) => {
      values._idSocio = socioCreado._id
      values.codigoSocio = socioCreado.codigo
      values.documentoSocio = socioCreado.numeroDocumento
      values.nombreSocio = socioCreado.razonSocial
      values.tipoDocumentoSocio = socioCreado.tipoDocumento

      setValues(values)
      closeModal()

      KeyEventUtil.leaveOnKeyEvent('inputselect-glosa')
    },
    [setValues, values]
  )

  const clickClear = React.useCallback(() => {
    values._idSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.nombreSocio = ''
    values.tipoDocumentoSocio = ''

    setValues(values)
    KeyEventUtil.leaveOnKeyEvent('codigoRucSelect')
  }, [setValues, values])

  return (
    <>
      <Form.Group>
        <Form.Label text='RUC' htmlFor='input-codigoRucSocio' md={12} />
        <Col md={12}>
          {iValue ? (
            <ClearInputGroup id='codigoRucSocio' iValue={`${values.documentoSocio} - ${values.nombreSocio}`} clickClear={clickClear} />
          ) : vTipoSocio === TiposSocioConstant.CLIENTE ? (
            <Select2Cliente disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} showNewButton onCreate={onCreateSocioHandler} />
          ) : vTipoSocio === TiposSocioConstant.PROVEEDOR ? (
            <Select2Proveedor disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} showNewButton onCreate={onCreateSocioHandler} />
          ) : (
            <Select2SocioOtros disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} showNewButton onCreate={onCreateSocioHandler} />
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
